export const EVOLVELOG_LIST_REQUEST = 'EVOLVELOG_LIST_REQUEST';

export const EVOLVELOG_LIST = 'EVOLVELOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_EVOLVELOG_PAGINATION = 'SET_EVOLVELOG_PAGINATION';

export const EVOLVELOG_PAGE_RESET = 'EVOLVELOG_PAGE_RESET';
